import FloatingDefault from '../../lib/jin/svgchartlib/01_Charts/08_Floating/includes/primitives/Data'

export default FloatingDefault